import { create } from 'zustand';
import { api } from '../services/api';

export const useTrafficStore = create((set, get) => ({
  stats: null,
  list: null,
  dashboardSummary: null,
  isLoading: false,
  error: null,

  // Загрузка общей статистики
  fetchStats: async () => {
    set({ isLoading: true, error: null });
    try {
      const data = await api.getTrafficSourceStats();
      set({ stats: data, isLoading: false });
      return data;
    } catch (error) {
      set({ error: error.message, isLoading: false });
      return null;
    }
  },

  // Загрузка постраничного списка
  fetchList: async (page = 1, limit = 20, filterType = null) => {
    set({ isLoading: true, error: null });
    try {
      const data = await api.getTrafficSourceList(page, limit, filterType);
      set({ list: data, isLoading: false });
      return data;
    } catch (error) {
      set({ error: error.message, isLoading: false });
      return null;
    }
  },

  // Загрузка краткой сводки для дашборда
  fetchDashboardSummary: async () => {
    set({ isLoading: true, error: null });
    try {
      const data = await api.getTrafficSourceDashboardSummary();
      set({ dashboardSummary: data, isLoading: false });
      return data;
    } catch (error) {
      set({ error: error.message, isLoading: false });
      return null;
    }
  },

  // Очистка
  clear: () => {
    set({ stats: null, list: null, dashboardSummary: null, error: null });
  },

  // Сброс ошибки
  clearError: () => {
    set({ error: null });
  },
}));
